import { ISectionParameter } from '@features/productPreview/sections/ProductDescription/typescript';
import styles from '@features/productPreview/sections/ProductDescription/components/ProductProperties/ProductProperties.styles';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  properties: ISectionParameter[];
};
const ProductProperties = ({
  properties
}: PropsType) => {
  const propertiesWithNoIcon = properties.filter(property => property.icon === '' || property.icon === null);
  const propertiesWithIcon = properties.filter(property => property.icon !== '' && property.icon !== null);
  const middleIndex = Math.floor(propertiesWithIcon.length / 2);
  const columns = [propertiesWithIcon.slice(0, middleIndex), propertiesWithIcon.slice(middleIndex)];
  return <>
      <div sx={styles.container}>
        {columns.map((column, index) => <div key={`propertyColumn_${index}`} sx={styles.column}>
            {column.map(property => <div key={property.code} sx={styles.singleProperty}>
                <div sx={styles.imageContainer}>
                  <ResponsiveImage sx={styles.image} image={property.icon} alt={property.name} objectFit="contain" />
                </div>
                <div sx={styles.textContainer}>{property.name}</div>
              </div>)}
          </div>)}
      </div>
      <div sx={styles.properties}>
        <ul>
          {propertiesWithNoIcon.map((property, index) => <li key={index}>{property.name}</li>)}
        </ul>
      </div>
    </>;
};
export default ProductProperties;